export default {
  "content": "<path fill=\"#444\" d=\"M0 1c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "2",
    "fill": "none",
    "viewBox": "0 0 14 2"
  }
};